<template>
  <div class="search-for-calendar" v-if="searchedCalendars.length > 0 && query.length > 1">
    <div class="search-for-calendar__header">
      <div class="search-for-calendar__left">
        <div class="search-for-calendar__warning"><span class="icon-warning"></span>
        </div>
      </div>
      <h4 v-if="calendarType === 'users'">{{ $t('vue2.students.users_with_same_name') }}</h4>
      <h4 v-if="calendarType === 'students'">{{ $t('vue2.students.students_with_same_name') }}</h4>
    </div>
    <div class="search-for-calendar__body">
      <ul class="search-for-calendar__calendars">
        <li class="search-for-calendar__calendar" v-for="calendar in searchedCalendars">
          <div class="cal-name">{{ calendar.name }}</div>
          <div class="cal-klasses">
            <span v-for="(klass, key) in getStudentKlasses(calendar)"><span v-if="key !== 0">, </span>
              {{ klass.name }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    query: {
      type: String,
      default: ''
    },
    calendarType: {
      type: String,
      default: 'students'
    }
  },
  data () {
    return {
      searchQuery: '',
      search_timeout: null
    }
  },
  computed: {
    searchedCalendars () {
      return this.searchQuery.length > 0 ? this.activeCalendars.filter(cal => cal.name !== null ? cal.name.match(new RegExp(this.searchQuery, 'i')) : '') : []
    },
    activeCalendars () {
      return this.calendarType === 'students' ? this.students : this.users
    },
    calendars () {
      return this.$store.state.calendars
    },
    students () {
      return this.$store.getters.allStudentCalendars
    },
    users () {
      return this.$store.getters.userCalendars
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    }
  },
  watch: {
    query (val, oldVal) {
      this.debounceSearch(val)
    }
  },
  methods: {
    debounceSearch (val) {
      if (this.search_timeout) {
        clearTimeout(this.search_timeout)
      }
      this.search_timeout = setTimeout(_ => {
        this.searchQuery = val
      }, 400)
    },
    getStudentKlasses (student) {
      if (student.klasses) {
        return student.klasses.map(calId => {
          if (this.allCalendarsInHash[calId]) {
            return this.allCalendarsInHash[calId]
          }
        })
      } else {
        return []
      }
    }
  }
}
</script>

<style>
.search-for-calendar {
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 0.25rem;
}

.search-for-calendar__header {
  display: flex;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
}

.search-for-calendar__left {
  width: 50px;
}

.search-for-calendar__body {
  margin-left: calc(50px - 0.5rem);
}

.search-for-calendar__warning {
  background-color: #fffbeb;
  color: #ca844c;
  border: 1px solid #ca844c;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-for-calendar h4 {
  color: #a25c2f;
  padding-top: 0.25rem;
}

.search-for-calendar__calendar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}

.search-for-calendar__calendars > li:nth-child(even) {
  background-color: #eeeeee;
}

</style>



// WEBPACK FOOTER //
// SearchForCalendar.vue?6590348e